if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.requestId = 0;
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.errorHtml = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
      if (this.isProductPreview()) {
        this.removeAttribute('available');
        this.innerHTML = '';
        return;
      }
      if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
    }

    isProductPreview() {
      return window.location.pathname.includes('/products_preview') ||
        window.location.hostname.endsWith('.shopifypreview.com');
    }

    async fetchAvailability(variantId) {
      const requestId = ++this.requestId;
      if (this.isProductPreview() || !variantId) {
        this.removeAttribute('available');
        this.innerHTML = '';
        return;
      }
      this.dataset.variantId = variantId;
      let rootUrl = this.dataset.rootUrl || '/';
      if (!rootUrl.endsWith('/')) rootUrl += '/';
      try {
        const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`);
        if (!response.ok) throw new Error('Pickup availability request failed');
        const text = await response.text();
        if (requestId !== this.requestId) return;
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        if (!section) throw new Error('Pickup availability section unavailable');
        this.renderPreview(section);
      } catch (error) {
        if (requestId === this.requestId) this.renderError();
      }
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) this.fetchAvailability(variant.id);
      else {
        ++this.requestId;
        this.removeAttribute('available');
        this.innerHTML = '';
      }
    }

    renderError() {
      this.innerHTML = '';
      this.removeAttribute('available');
      if (this.isProductPreview() || !this.errorHtml) return;
      this.appendChild(this.errorHtml.cloneNode(true));
      this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(section) {
      const preview = section.querySelector('pickup-availability-preview');
      document.querySelector('pickup-availability-drawer')?.remove();
      if (!preview) {
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }
      this.innerHTML = preview.outerHTML;
      this.setAttribute('available', '');
      const drawer = section.querySelector('pickup-availability-drawer');
      if (drawer) document.body.appendChild(drawer);
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends BasicModal {});
}
